module.exports = __webpack_public_path__ + "static/media/gallery11.7e8b5a8a.jpg";